import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function cardmsgD({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div
            className={`${css.cardmsgD} cardmsgD3 GtmModuleData-section`}
            data-section-id={css.cardmsgD}
            data-section-title={t('unit_control')}
            style={{ height: '5.6rem' }}
        >
            <div className="card-msgs">
                <div className="card-title">{t('unit_control')}</div>
                <div className="card-desc">{t('unit_control_desc')}</div>
            </div>
            <div className="card-img" style={{ height: '5.6rem' }}>
                <EFPic name={[`12WirelessControl2.webp`, `12WirelessControl2.png`]} className="fullImgs" alt={t('unit_control')} />
            </div>
        </div>
    );
}
